import { useEffect, useLayoutEffect, useRef, useState, type RefObject } from 'react';

const useIsomorphicLayout = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const useContainerWidth = <T extends HTMLElement>(): [RefObject<T | null>, number] => {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(0);

  useIsomorphicLayout(() => {
    const element = ref.current;
    if (!element) return;

    setWidth(element.offsetWidth);

    if (typeof ResizeObserver === 'undefined') return;

    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return [ref, width];
};
